<script>
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: [],
      required: true
    }
  },
  data() {
    return {
      switch: null,
      values: []
    };
  },
  mounted() {
    //do something after mounting vue instance
    this.switch = this.$refs.switch;
  },
  methods: {
    onChange(val, index) {
      // let index1 = this.options.findIndex((obj => obj.position == index))
      this.options[index].value = val;
      let option = this.options[index].text;
      if (this.values.indexOf(option) !== -1) {
        this.values.splice(this.values.indexOf(option), 1);
      } else {
        this.values.push(option);
      }
      this.$emit("propChange", {
        options: this.options,
        value: this.values
      });
    }
  },
  created () {
    this.options.forEach((opt, index) => {
      if (opt.value) {
      let option = opt.text;
      this.values.push(option);
      // if (this.values.indexOf(option) !== -1) {
      //   this.values.splice(this.values.indexOf(option), 1);
      // } else {
      //   this.values.push(option);
      // }
      this.$emit("propChange", {
        options: this.options,
        value: this.values
      });

      }
    })
  }
};
</script>
<template>
  <f7-list class="switch-list inputs-list">
    <f7-list-item class="label-color" v-if="label != ''" :title="label" group-title></f7-list-item>
    <f7-list-item class="input-wrapper" v-for="(option, index) in options" :key="index">
      <f7-label class="switchlbl" :inline="true">{{option.text}}</f7-label>
      <f7-toggle  @input="option.value = $event.target.checked" :checked="option.value"  @change="onChange($event.target.checked ,index)" :value="`${option.value}`" ></f7-toggle>
    </f7-list-item>
  </f7-list>
</template>
<style scoped>
.list {
  margin: 15px 0;
}
.switchlbl {
  width: 85% !important;
  white-space: normal;
  line-height: 21px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/SwitchGroup.vue